import { Injectable, inject } from '@angular/core';
import { DocumentoUpload } from '../interfaces/archivo.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({
  providedIn: 'root'
})
export class FileNameParserService {

  private invalidFileNames: string[] = [];

  private coreService = inject(CoreService);

  // private readonly regex = /^([\w\d]+)_([\w\d]+)_([\w\d]{2,3})_([\w\d]+)_([\w\d]{3})_((0[1-9]|[1-2]\d|3[0-1])(0[1-9]|1[0-2])\d{4})\.\w+$/;
  // private readonly regex = /^([\w\d]{1,3})_([\w\d]+)_([\w\d]{2,3})_([\w\d]+)_([\w\d]{3})_((0[1-9]|[1-2]\d|3[0-1])(0[1-9]|1[0-2])\d{4})\.\w+$/;
  private readonly regex = /^([\w\d]{1,3})_([\w\d]+)_([\w\d]{2,3})_([\w\d\-\/]+)_([\w\d]{3})_((0[1-9]|[1-2]\d|3[0-1])(0[1-9]|1[0-2])\d{4})\.\w+$/;

  public nameDoctFile: string = '';


  constructor() { }

  extractDataFromFileName( fileName: string ): DocumentoUpload | null {
    const match = fileName.match(this.regex);

    if (match) {
      const date = this.parseDateString2(match[6]);
      if (match[6] !== null) {
        // console.log(date)
        // console.log("Fecha formateada:", match[6]);
      } else {
        this.coreService.openErrorSnackbar("La cadena no tiene el formato esperado.", 'Ok');
        // console.log("La cadena no tiene el formato esperado.");
      }
      const nameDoctFile: DocumentoUpload = {
        typeID:     match[1],
        numeroID:   match[2],
        typeDoct:   match[3],
        numeroDoct: match[4],
        CO:         match[5],
        fecha:      date,
      };


      return nameDoctFile;
    }
    this.showInvalidFileNameAlert(fileName);
    return null;
  }


  parseDateString2(dateString: string): Date {
    const match = dateString.match(/^(\d{2})(\d{2})(\d{4})$/);

    if (match) {
      const day = parseInt(match[1]);
      const month = parseInt(match[2]) - 1; // Restamos 1 porque los meses en JavaScript son 0-11
      const year = parseInt(match[3]);

      if (day >= 1 && day <= 31 && month >= 0 && month <= 11) {
        return new Date(year, month, day);
      }
    }

    return new Date(NaN);
  }


  private showInvalidFileNameAlert(fileName: string): void {
    this.invalidFileNames.push(fileName);
  }



}
